import { useQuery } from '@tanstack/react-query';
import { engagementService } from '../services/engagement.service';

export function useLotteryResults(cycleKey: string) {
  return useQuery({
    queryKey: ['engagement', 'lottery-results', cycleKey],
    queryFn: () => engagementService.getLotteryResults(cycleKey),
    enabled: Boolean(cycleKey),
  });
}
